'use es6';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const IframeWrapper = styled.div.withConfig({
  displayName: "EmbeddedSignup__IframeWrapper",
  componentId: "yd4jyz-0"
})(["height:100vh;width:100%;"]);
const EmbeddedSignup = ({
  env = 'prod'
}) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.onload = () => {
      new window.SignupEmbedder().setEnvironment(env).setFlow('academy').setOptions(new window.SignupEmbedderOptions().setShouldShowMessaging()).attachTo('#embedded-signup-iframe');
    };
    script.src = `https://js.hubspot${env === 'qa' ? 'qa' : ''}.com/signup-embedder/v1.js`;
    script.async = true;
    document.body.appendChild(script);
  }, [env]);
  return /*#__PURE__*/_jsx(IframeWrapper, {
    id: "embedded-signup-iframe"
  });
};
EmbeddedSignup.propTypes = {
  env: PropTypes.string
};
export default EmbeddedSignup;